import { render } from "./ModalDifferencesContent.vue?vue&type=template&id=675b2cdf&scoped=true"
import script from "./ModalDifferencesContent.vue?vue&type=script&lang=js"
export * from "./ModalDifferencesContent.vue?vue&type=script&lang=js"

import "./ModalDifferencesContent.vue?vue&type=style&index=0&id=675b2cdf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675b2cdf"]])

export default __exports__